import { animate, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { LoadingService } from './loading.service';

@Component({
  selector: 'app-loading',
  template: `
    <div class="loading" [@inOutAnimation] *ngIf="_loadingService.isLoading">
      <img class="img-loading" src="assets/icon/logo.png" alt="" />
    </div>
  `,
  styles: [
    `
      .loading {
        background-color: rgba(0, 0, 0, 0.644);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999999;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .img-loading {
        width: 60px;
        animation-name: rotation;
        animation-duration: 3s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
      }

      @keyframes rotation {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `,
  ],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.2s ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0.2s ease-in', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class LoadingComponent {

  constructor(
    public _loadingService: LoadingService
  ) { }
}
